var map = {
	"./Mosquito_larva_04.jpg": 438,
	"./Mosquito_larva_05 (2).jpg": 3813,
	"./Mosquito_larva_05.jpg": 1858,
	"./Mosquito_larva_07.jpg": 1990,
	"./Mosquito_larva_09.jpg": 9785,
	"./Mosquito_larva_10.jpg": 9008,
	"./Mosquito_larva_13.jpg": 3463,
	"./Mosquito_larva_17.jpg": 3951,
	"./Mosquito_larva_18.jpg": 8504,
	"./Mosquito_larva_20.jpg": 2989,
	"./Mosquito_larva_21.jpg": 3283,
	"./Mosquito_larva_24.jpg": 9275,
	"./Mosquito_larva_26.jpg": 1799,
	"./Mosquito_larva_27.jpg": 5139,
	"./Mosquito_larva_28.jpg": 4092,
	"./Mosquito_larva_29.jpg": 2202,
	"./Mosquito_larva_32.jpg": 9709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3108;